/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Email_ComplainedInputs */

const en_task_email_complained = /** @type {(inputs: Task_Email_ComplainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assignee marked the email as spam`)
};

const pt_br2_task_email_complained = /** @type {(inputs: Task_Email_ComplainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O responsável marcou o e-mail como spam`)
};

/**
* | output |
* | --- |
* | "The assignee marked the email as spam" |
*
* @param {Task_Email_ComplainedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_email_complained = /** @type {((inputs?: Task_Email_ComplainedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Email_ComplainedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_email_complained(inputs)
	return pt_br2_task_email_complained(inputs)
});